// Generated by purs version 0.14.3
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Functor_Tagged = require("../Data.Functor.Tagged/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Network_Ethereum_Core_BigNumber = require("../Network.Ethereum.Core.BigNumber/index.js");
var Network_Ethereum_Core_HexString = require("../Network.Ethereum.Core.HexString/index.js");
var Network_Ethereum_Web3_Solidity_AbiEncoding = require("../Network.Ethereum.Web3.Solidity.AbiEncoding/index.js");
var Network_Ethereum_Web3_Solidity_EncodingType = require("../Network.Ethereum.Web3.Solidity.EncodingType/index.js");
var Record = require("../Record/index.js");
var Text_Parsing_Parser = require("../Text.Parsing.Parser/index.js");
var Text_Parsing_Parser_Combinators = require("../Text.Parsing.Parser.Combinators/index.js");
var Type_Data_RowList = require("../Type.Data.RowList/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var RecordFieldsIso = function (fromRecordFields, toRecordFields) {
    this.fromRecordFields = fromRecordFields;
    this.toRecordFields = toRecordFields;
};
var GenericABIEncode = function (genericToDataBuilder) {
    this.genericToDataBuilder = genericToDataBuilder;
};
var GenericABIDecode = function (genericFromDataParser) {
    this.genericFromDataParser = genericFromDataParser;
};
var EncodedValue = (function () {
    function EncodedValue(value0) {
        this.value0 = value0;
    };
    EncodedValue.create = function (value0) {
        return new EncodedValue(value0);
    };
    return EncodedValue;
})();
var ArgsToRowListProxy = function (argsToRowListProxy) {
    this.argsToRowListProxy = argsToRowListProxy;
};
var ABIData = function (_serialize) {
    this["_serialize"] = _serialize;
};
var toRecordFields = function (dict) {
    return dict.toRecordFields;
};
var isoRecordBaseNull = new RecordFieldsIso(function (v) {
    return function (v1) {
        return Data_Generic_Rep.NoArguments.value;
    };
}, function (v) {
    return function (v1) {
        return {};
    };
});
var isoRecordBase = function (dictIsSymbol) {
    return function (dictCons) {
        return function (dictLacks) {
            return new RecordFieldsIso(function (v) {
                return function (r) {
                    return Data_Functor_Tagged.tagged(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(r));
                };
            }, function (v) {
                return function (v1) {
                    return Record.insert(dictIsSymbol)()()(Type_Proxy["Proxy"].value)(Data_Functor_Tagged.untagged(v1))({});
                };
            });
        };
    };
};
var genericToRecordFields = function (dictRecordFieldsIso) {
    return function (dictGeneric) {
        return function (a) {
            var v = Data_Generic_Rep.from(dictGeneric)(a);
            return toRecordFields(dictRecordFieldsIso)(Type_Data_RowList.RLProxy.value)(v);
        };
    };
};
var genericToDataBuilder = function (dict) {
    return dict.genericToDataBuilder;
};
var genericFromDataParser = function (dict) {
    return dict.genericFromDataParser;
};
var genericABIEncode = function (dictGeneric) {
    return function (dictGenericABIEncode) {
        var $113 = genericToDataBuilder(dictGenericABIEncode);
        var $114 = Data_Generic_Rep.from(dictGeneric);
        return function ($115) {
            return $113($114($115));
        };
    };
};
var genericABIDecode = function (dictGeneric) {
    return function (dictGenericABIDecode) {
        return Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Data_Generic_Rep.to(dictGeneric))(genericFromDataParser(dictGenericABIDecode));
    };
};
var genericFromData = function (dictGeneric) {
    return function (dictGenericABIDecode) {
        return Data_Function.flip(Text_Parsing_Parser.runParser)(genericABIDecode(dictGeneric)(dictGenericABIDecode));
    };
};
var fromRecordFields = function (dict) {
    return dict.fromRecordFields;
};
var genericFromRecordFields = function (dictRecordFieldsIso) {
    return function (dictGeneric) {
        return function (r) {
            return Data_Generic_Rep.to(dictGeneric)(Data_Generic_Rep.Constructor(fromRecordFields(dictRecordFieldsIso)(Type_Data_RowList.RLProxy.value)(r)));
        };
    };
};
var isoRecordInductive = function (dictRecordFieldsIso) {
    return function (dictCons) {
        return function (dictLacks) {
            return function (dictIsSymbol) {
                return function (dictListToRow) {
                    return new RecordFieldsIso(function (v) {
                        return function (r) {
                            var before = Record["delete"](dictIsSymbol)()()(Type_Proxy["Proxy"].value)(r);
                            var rest = fromRecordFields(dictRecordFieldsIso)(Type_Data_RowList.RLProxy.value)(before);
                            var a = Data_Functor_Tagged.tagged(Record.get(dictIsSymbol)()(Type_Proxy["Proxy"].value)(r));
                            return new Data_Generic_Rep.Product(a, rest);
                        };
                    }, function (v) {
                        return function (v1) {
                            var rest = toRecordFields(dictRecordFieldsIso)(Type_Data_RowList.RLProxy.value)(v1.value1);
                            return Record.insert(dictIsSymbol)()()(Type_Proxy["Proxy"].value)(Data_Functor_Tagged.untagged(v1.value0))(rest);
                        };
                    });
                };
            };
        };
    };
};
var eqEncodedValue = new Data_Eq.Eq(function (v) {
    return function (v1) {
        return v.value0.order === v1.value0.order;
    };
});
var ordEncodedValue = new Data_Ord.Ord(function () {
    return eqEncodedValue;
}, function (v) {
    return function (v1) {
        return Data_Ord.compare(Data_Ord.ordInt)(v.value0.order)(v1.value0.order);
    };
});
var dParser = function (dictABIDecode) {
    return Control_Bind.bind(Text_Parsing_Parser.bindParserT(Data_Identity.monadIdentity))(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Network_Ethereum_Core_BigNumber.unsafeToInt)(Network_Ethereum_Web3_Solidity_AbiEncoding.fromDataParser(Network_Ethereum_Web3_Solidity_AbiEncoding.abiDecodeAlgebra)))(function (dataOffset) {
        return Text_Parsing_Parser_Combinators.lookAhead(Data_Identity.monadIdentity)(Control_Bind.bind(Text_Parsing_Parser.bindParserT(Data_Identity.monadIdentity))(Control_Monad_State_Class.get(Text_Parsing_Parser.monadStateParserT(Data_Identity.monadIdentity)))(function (v) {
            return Control_Bind.bind(Text_Parsing_Parser.bindParserT(Data_Identity.monadIdentity))(Network_Ethereum_Web3_Solidity_AbiEncoding.take(Data_Identity.monadIdentity)((dataOffset * 2 | 0) - (v.value1.column - 1 | 0) | 0))(function () {
                return Network_Ethereum_Web3_Solidity_AbiEncoding.fromDataParser(dictABIDecode);
            });
        }));
    });
};
var factorParser = function (dictABIDecode) {
    return function (dictEncodingType) {
        if (!Network_Ethereum_Web3_Solidity_EncodingType.isDynamic(dictEncodingType)(Type_Proxy["Proxy"].value)) {
            return Network_Ethereum_Web3_Solidity_AbiEncoding.fromDataParser(dictABIDecode);
        };
        if (Data_Boolean.otherwise) {
            return dParser(dictABIDecode);
        };
        throw new Error("Failed pattern match at Network.Ethereum.Web3.Solidity.Generic (line 207, column 1 - line 207, column 78): " + [  ]);
    };
};
var inductiveAbiDecode = function (dictEncodingType) {
    return function (dictABIDecode) {
        return function (dictGenericABIDecode) {
            return new GenericABIDecode(Control_Apply.apply(Text_Parsing_Parser.applyParserT(Data_Identity.monadIdentity))(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Data_Generic_Rep.Product.create)(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Data_Generic_Rep.Argument)(factorParser(dictABIDecode)(dictEncodingType))))(genericFromDataParser(dictGenericABIDecode)));
        };
    };
};
var combineEncodedValues = function (encodings) {
    var headsOffset = Data_Array.foldl(function (acc) {
        return function (v) {
            if (v.value0.offset instanceof Data_Maybe.Nothing) {
                return acc + Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(Network_Ethereum_Core_HexString.hexLength(v.value0.encoding))(2) | 0;
            };
            if (v.value0.offset instanceof Data_Maybe.Just) {
                return acc + 32 | 0;
            };
            throw new Error("Failed pattern match at Network.Ethereum.Web3.Solidity.Generic (line 108, column 34 - line 110, column 29): " + [ v.value0.offset.constructor.name ]);
        };
    })(0)(encodings);
    var adjust = function (n) {
        return Data_Functor.map(Data_Functor.functorArray)(function (v) {
            return new EncodedValue({
                order: v.value0.order,
                offset: Data_Functor.map(Data_Maybe.functorMaybe)(Data_Semiring.add(Data_Semiring.semiringInt)(n))(v.value0.offset),
                encoding: v.value0.encoding
            });
        });
    };
    var addTailOffsets = function ($copy_init) {
        return function ($copy_acc) {
            return function ($copy_es) {
                var $tco_var_init = $copy_init;
                var $tco_var_acc = $copy_acc;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(init, acc, es) {
                    var v = Data_Array.uncons(es);
                    if (v instanceof Data_Maybe.Nothing) {
                        $tco_done = true;
                        return Data_Array.reverse(acc);
                    };
                    if (v instanceof Data_Maybe.Just) {
                        if (v.value0.head.value0.offset instanceof Data_Maybe.Nothing) {
                            $tco_var_init = init;
                            $tco_var_acc = Data_Array.cons(v.value0.head)(acc);
                            $copy_es = v.value0.tail;
                            return;
                        };
                        if (v.value0.head.value0.offset instanceof Data_Maybe.Just) {
                            $tco_var_init = init;
                            $tco_var_acc = Data_Array.cons(v.value0.head)(acc);
                            $copy_es = adjust(Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(Network_Ethereum_Core_HexString.hexLength(v.value0.head.value0.encoding))(2))(v.value0.tail);
                            return;
                        };
                        throw new Error("Failed pattern match at Network.Ethereum.Web3.Solidity.Generic (line 101, column 9 - line 103, column 98): " + [ v.value0.head.value0.offset.constructor.name ]);
                    };
                    throw new Error("Failed pattern match at Network.Ethereum.Web3.Solidity.Generic (line 95, column 32 - line 103, column 98): " + [ v.constructor.name ]);
                };
                while (!$tco_done) {
                    $tco_result = $tco_loop($tco_var_init, $tco_var_acc, $copy_es);
                };
                return $tco_result;
            };
        };
    };
    var sortedEs = adjust(headsOffset)(Data_Array.sort(ordEncodedValue)(encodings));
    var encodings$prime = addTailOffsets(headsOffset)([  ])(sortedEs);
    var tails = Data_Array.foldl(function (acc) {
        return function (v) {
            if (v.value0.offset instanceof Data_Maybe.Nothing) {
                return acc;
            };
            if (v.value0.offset instanceof Data_Maybe.Just) {
                return Data_Semigroup.append(Network_Ethereum_Core_HexString.semigpStringEq)(acc)(v.value0.encoding);
            };
            throw new Error("Failed pattern match at Network.Ethereum.Web3.Solidity.Generic (line 82, column 38 - line 84, column 42): " + [ v.value0.offset.constructor.name ]);
        };
    })(Data_Monoid.mempty(Network_Ethereum_Core_HexString.monoidStringEq))(encodings$prime);
    var heads = Data_Array.foldl(function (acc) {
        return function (v) {
            if (v.value0.offset instanceof Data_Maybe.Nothing) {
                return Data_Semigroup.append(Network_Ethereum_Core_HexString.semigpStringEq)(acc)(v.value0.encoding);
            };
            if (v.value0.offset instanceof Data_Maybe.Just) {
                return Data_Semigroup.append(Network_Ethereum_Core_HexString.semigpStringEq)(acc)(Network_Ethereum_Web3_Solidity_AbiEncoding.toDataBuilder(Network_Ethereum_Web3_Solidity_AbiEncoding.abiEncodeInt)(v.value0.offset.value0));
            };
            throw new Error("Failed pattern match at Network.Ethereum.Web3.Solidity.Generic (line 73, column 38 - line 75, column 47): " + [ v.value0.offset.constructor.name ]);
        };
    })(Data_Monoid.mempty(Network_Ethereum_Core_HexString.monoidStringEq))(encodings$prime);
    return Data_Semigroup.append(Network_Ethereum_Core_HexString.semigpStringEq)(heads)(tails);
};
var baseNullAbiDecode = new GenericABIDecode(Control_Applicative.pure(Text_Parsing_Parser.applicativeParserT(Data_Identity.monadIdentity))(Data_Generic_Rep.NoArguments.value));
var baseAbiDecode = function (dictEncodingType) {
    return function (dictABIDecode) {
        return new GenericABIDecode(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Data_Generic_Rep.Argument)(factorParser(dictABIDecode)(dictEncodingType)));
    };
};
var argsToRowListProxyInductive = function (dictArgsToRowListProxy) {
    return new ArgsToRowListProxy(function (v) {
        return Type_Data_RowList.RLProxy.value;
    });
};
var argsToRowListProxyBaseNull = new ArgsToRowListProxy(function (v) {
    return Type_Data_RowList.RLProxy.value;
});
var argsToRowListProxyBase = new ArgsToRowListProxy(function (v) {
    return Type_Data_RowList.RLProxy.value;
});
var argsToRowListProxy = function (dict) {
    return dict.argsToRowListProxy;
};
var abiDecodeConstructor = function (dictGenericABIDecode) {
    return new GenericABIDecode(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Data_Generic_Rep.Constructor)(genericFromDataParser(dictGenericABIDecode)));
};
var abiDataBaseNull = new ABIData(function (encoded) {
    return function (v) {
        return encoded;
    };
});
var abiDataBase = function (dictEncodingType) {
    return function (dictABIEncode) {
        return new ABIData(function (encoded) {
            return function (v) {
                var staticEncoding = new EncodedValue({
                    encoding: Network_Ethereum_Web3_Solidity_AbiEncoding.toDataBuilder(dictABIEncode)(v),
                    offset: Data_Maybe.Nothing.value,
                    order: 1 + Data_Array.length(encoded) | 0
                });
                var dynEncoding = new EncodedValue({
                    encoding: Network_Ethereum_Web3_Solidity_AbiEncoding.toDataBuilder(dictABIEncode)(v),
                    offset: new Data_Maybe.Just(0),
                    order: 1 + Data_Array.length(encoded) | 0
                });
                var $106 = Network_Ethereum_Web3_Solidity_EncodingType.isDynamic(dictEncodingType)(Type_Proxy["Proxy"].value);
                if ($106) {
                    return Data_Array.cons(dynEncoding)(encoded);
                };
                return Data_Array.cons(staticEncoding)(encoded);
            };
        });
    };
};
var _serialize = function (dict) {
    return dict["_serialize"];
};
var abiDataInductive = function (dictEncodingType) {
    return function (dictABIEncode) {
        return function (dictABIData) {
            return new ABIData(function (encoded) {
                return function (v) {
                    var staticEncoding = new EncodedValue({
                        encoding: Network_Ethereum_Web3_Solidity_AbiEncoding.toDataBuilder(dictABIEncode)(v.value0),
                        offset: Data_Maybe.Nothing.value,
                        order: 1 + Data_Array.length(encoded) | 0
                    });
                    var dynEncoding = new EncodedValue({
                        encoding: Network_Ethereum_Web3_Solidity_AbiEncoding.toDataBuilder(dictABIEncode)(v.value0),
                        offset: new Data_Maybe.Just(0),
                        order: 1 + Data_Array.length(encoded) | 0
                    });
                    var $109 = Network_Ethereum_Web3_Solidity_EncodingType.isDynamic(dictEncodingType)(Type_Proxy["Proxy"].value);
                    if ($109) {
                        return _serialize(dictABIData)(Data_Array.cons(dynEncoding)(encoded))(v.value1);
                    };
                    return _serialize(dictABIData)(Data_Array.cons(staticEncoding)(encoded))(v.value1);
                };
            });
        };
    };
};
var abiEncodeConstructor = function (dictABIData) {
    return new GenericABIEncode(function (v) {
        return combineEncodedValues(_serialize(dictABIData)([  ])(v));
    });
};
module.exports = {
    GenericABIEncode: GenericABIEncode,
    GenericABIDecode: GenericABIDecode,
    ABIData: ABIData,
    "_serialize": _serialize,
    genericFromDataParser: genericFromDataParser,
    genericToDataBuilder: genericToDataBuilder,
    genericABIEncode: genericABIEncode,
    genericABIDecode: genericABIDecode,
    genericFromData: genericFromData,
    RecordFieldsIso: RecordFieldsIso,
    toRecordFields: toRecordFields,
    fromRecordFields: fromRecordFields,
    genericToRecordFields: genericToRecordFields,
    genericFromRecordFields: genericFromRecordFields,
    ArgsToRowListProxy: ArgsToRowListProxy,
    argsToRowListProxy: argsToRowListProxy,
    eqEncodedValue: eqEncodedValue,
    ordEncodedValue: ordEncodedValue,
    abiDataBaseNull: abiDataBaseNull,
    abiDataBase: abiDataBase,
    abiDataInductive: abiDataInductive,
    abiEncodeConstructor: abiEncodeConstructor,
    baseAbiDecode: baseAbiDecode,
    baseNullAbiDecode: baseNullAbiDecode,
    inductiveAbiDecode: inductiveAbiDecode,
    abiDecodeConstructor: abiDecodeConstructor,
    argsToRowListProxyBaseNull: argsToRowListProxyBaseNull,
    argsToRowListProxyBase: argsToRowListProxyBase,
    argsToRowListProxyInductive: argsToRowListProxyInductive,
    isoRecordBase: isoRecordBase,
    isoRecordBaseNull: isoRecordBaseNull,
    isoRecordInductive: isoRecordInductive
};
